import React, { Component } from 'react';
import { scrollTo } from 'react-static';
import Sticky from 'react-stickynode';
import styled from 'styled-components';
//
import Grid from 'components/grid';
import Job from 'components/job';
import Thumbnail, { ThumbnailContainer } from 'components/thumbnail';
import Popup from 'components/popup';
import { RichText, SlizeZone } from 'components/prismic';
import Instagram from 'components/instagram';
import SocialMediaWall from 'components/social-media-wall';
import Subscribe from 'components/subscribe';
//
import {
  ContentContainer,
  ContentMain,
  ContentSide
} from 'components/styled/content-container';
//
import Filter from './filter';
//
class Client extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFilter: '*',
      content: props.job && props.job.content ? props.job.content : null
    };
  }

  activateJob = (e, thumbnail) => {
    e.preventDefault();
    this.setState({ content: thumbnail.content });
  };

  deActivateJob = e => {
    e.preventDefault();
    this.setState({ content: null });
  };

  activateFilter = (e, activeFilter) => {
    e.preventDefault();
    scrollTo(0, { duration: 420 });
    if (this.state.activeFilter === activeFilter) {
      this.setState({ activeFilter: '*' });
    } else {
      this.setState({ activeFilter });
    }
  };

  render() {
    const {
      bio,
      filters,
      mailchimp,
      thumbnail_ratio,
      thumbnails,
      title
    } = this.props;

    const { activeFilter, content } = this.state;

    return (
      <Wrap id="client">
        {content && (
          <Popup
            closeTo="/"
            closeTitle={title}
            handleClose={this.deActivateJob}
          >
            {content && <Job content={content} />}
          </Popup>
        )}

        <ContentContainer>
          <ContentMain>
            {filters && (
              <Filter
                activeFilter={activeFilter}
                activateFilter={this.activateFilter}
                filters={filters}
              />
            )}

            <Sticky top={54}>
              {bio && (activeFilter === '.bio' || activeFilter === '*') && (
                <RichText {...bio} />
              )}
              {mailchimp && activeFilter === '*' && (
                <Subscribe {...mailchimp} />
              )}
              {thumbnails && thumbnails.length > 0 && (
                <ThumbnailContainer>
                  <Grid filter={activeFilter}>
                    {thumbnails.map(thumbnail => (
                      <Thumbnail
                        key={thumbnail.id}
                        handleClick={this.activateJob}
                        ratio={thumbnail_ratio}
                        thumbnail={thumbnail}
                      />
                    ))}
                  </Grid>
                </ThumbnailContainer>
              )}
            </Sticky>
          </ContentMain>
        </ContentContainer>
      </Wrap>
    );
  }
}

export default Client;
//
const Wrap = styled.div`
  width: 100%;
`;
